import { createApi } from '@reduxjs/toolkit/query/react';
import { apiAuthenticatedQuery } from './baseQuery';
import {
  BusinessTypes,
  Prefecture,
  WasteItem,
  WorkCategory,
} from '../types/others';
import { errorTagTypes, handleErrorTags } from './handleErrorTags';

export const othersApi = createApi({
  baseQuery: apiAuthenticatedQuery,
  reducerPath: 'others',
  tagTypes: ['Others', ...errorTagTypes],
  endpoints: (builder) => ({
    getWorkCategories: builder.query<WorkCategory[], void>({
      query: () => ({ url: `/work-categories` }),
      providesTags: (_res, error) => handleErrorTags(error),
    }),
    getWasteItems: builder.query<WasteItem[], void>({
      query: () => ({ url: `/waste-items` }),
      providesTags: (_res, error) => handleErrorTags(error),
    }),
    getPrefecture: builder.query<Prefecture[], void>({
      query: () => ({ url: `/prefectures` }),
      providesTags: (_res, error) => handleErrorTags(error),
    }),
    getBusinessTypes: builder.query<BusinessTypes[], void>({
      query: () => ({ url: `/business-types` }),
      providesTags: (_res, error) => handleErrorTags(error),
    }),
  }),
});

export const {
  useGetWorkCategoriesQuery,
  useGetWasteItemsQuery,
  useGetPrefectureQuery,
  useGetBusinessTypesQuery,
} = othersApi;
